export const LsIconTypes = [
    'add',
    'android',
    'calendar',
    'cancel',
    'chat',
    'checkmark',
    'checkoutline',
    'closeoutline',
    'chevron',
    'close',
    'copy',
    'dashes',
    'delete',
    'drag',
    'edit',
    'email',
    'hamburger',
    'hide',
    'hourglass',
    'ios',
    'mobile',
    'more',
    'otc',
    'pin',
    'quote',
    'ratings',
    'skip',
    'sms',
    'star',
    'time',
    'user',
    'view',
];

export const LsIconSizes = {
    xs: 10,
    sm: 15,
    md: 20,
    lg: 25,
    xlg: 30,
    xxlg: 40,
};
